import { FC, ReactNode, Suspense } from 'react'
import useLogin from '../hooks/useLogin'
import GetPhoneNumber from './getPhoneNumber/GetPhoneNumber'
import GetVerificationCode from './getVerificationCode/GetVerificationCode'
import GetInformation from './getInformation/GetInformation'
import ShowHostPanelCTA from './showHostPanelCTA/ShowHostPanelCTA'
import Box from '@/components/UI/box/Box'
import Header from './header/Header'

interface LoginStepsProps {
  header?: ReactNode
}

const LoginSteps: FC<LoginStepsProps> = ({ header }) => {
  const { step } = useLogin()
  return (
    <Box>
      <Suspense>
        {header ? header : <Header />}
        {step === 'GETPHONENUMBER' && <GetPhoneNumber />}
        {step === 'GETVERIFICATIONCODE' && <GetVerificationCode />}
        {step === 'GETINFORMATION' && <GetInformation />}
        {step === 'SHOWHOSTPANELCTA' && <ShowHostPanelCTA />}
      </Suspense>
    </Box>
  )
}

export default LoginSteps
